// rxjs-compat must be imported in the same bundle as the app code so its
// prototype patches (e.g. Observable.prototype.filter) apply to the same
// rxjs instance that app modules use. With esbuild each entry point bundles
// its own rxjs, so importing rxjs-compat from polyfill.ts doesn't help here.
import 'rxjs-compat';

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';

// Configure DevExpress license key — must run before any DevExtreme widget initializes
import { configureDevExpress } from './devextreme-config';

import { GlobalNotificationModule } from './GlobalNotification/globalnotification.module';

export function main() {
    configureDevExpress();
    enableProdMode();
    return platformBrowserDynamic().bootstrapModule(GlobalNotificationModule, {
        applicationProviders: [provideZoneChangeDetection()],
    });
}

if (document.readyState === 'complete') {
    main();
} else {
    document.addEventListener('DOMContentLoaded', main.bind(null));
}
